import { Logo, useIsDesktop } from '@kanda-libs/ks-design-library';
import { ReactComponent as Star } from './Star.svg';
import TrustpilotStars from './Stars';
import useTrustpilotBar from './useTrustpilotBar';

export interface TrustpilotBarProps {
  href?: string;
  wrapperClassName?: string;
}

const TrustpilotBar: React.FunctionComponent<TrustpilotBarProps> = function ({
  href = 'https://uk.trustpilot.com/review/getkanda.com',
  wrapperClassName = 'flex w-full',
}) {
  const { stars, reviews, rating, className } =
    useTrustpilotBar(wrapperClassName);
  const isDesktop = useIsDesktop();

  return (
    <a href={href} target="_blank" rel="noreferrer" className={className}>
      <div className="flex flex-row px-4 py-2 bg-neutral-100 mx-auto gap-x-6">
        <Logo className="my-auto" />
        <div className="flex flex-col">
          <div className="flex flex-row gap-x-1 ml-auto">
            <p className="text-12-18 my-auto text-neutral-900">
              {reviews} Reviews{' '}
            </p>
            <span className="w-1 h-1 min-w-1 mx-1 bg-neutral-700 my-auto rounded-full" />
            <p className="text-12-18 my-auto text-neutral-900">{rating}</p>
          </div>
          <TrustpilotStars stars={stars} />
          <div className="flex flex-row gap-x-2 mt-auto ml-auto">
            <Star
              width={isDesktop ? 16 : 14}
              height={isDesktop ? 16 : 14}
              className="my-auto text-neutral-900"
            />
            <p>Trustpilot</p>
          </div>
        </div>
      </div>
    </a>
  );
};

export default TrustpilotBar;
